import { ChartDataType } from '@frontend/components/interface';
import { ChartLine } from '@frontend/components/ui';
import { CHART_DATA_EMPTY_KEY_PREFIX } from '@frontend/components/utils';
import { useGetProjectID } from '@frontend/editor/data-access';
import { usePostDataDashboardSourceCommentReplyChart } from '@frontend/sorghum/data-access';
import {
  PostDataDashboardProps,
  PostDataDashboardSourceCommentReplyChartResponse,
} from '@frontend/sorghum/interface';
import { dayjs } from '@frontend/sorghum/utils';

import { set } from 'lodash';
import { FC, useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

export const DataDashboardSourceCommentAutoReplyChart: FC<
  PostDataDashboardProps
> = ({ startDate, endDate, condition, period }: PostDataDashboardProps) => {
  const [t] = useTranslation();
  const { data: projectID } = useGetProjectID();
  const [chartData, setChartData] = useState<ChartDataType[]>([]);
  const { mutate: queryData, isLoading } =
    usePostDataDashboardSourceCommentReplyChart();
  const currentLocale = dayjs().locale();

  const onSuccess = useCallback(
    (data: PostDataDashboardSourceCommentReplyChartResponse[]) => {
      setChartData(
        data.map((i) => {
          let newName = '';
          switch (period) {
            case 1: {
              newName = dayjs(i.startDate).format('MM/DD');
              break;
            }
            case 2: {
              newName =
                dayjs(i.startDate).format('MM/DD') +
                ' - ' +
                dayjs(i.endDate).format('MM/DD');
              break;
            }
            case 3: {
              newName = dayjs(i.startDate).format('MMM');
              break;
            }
          }
          const chartData = {
            name: newName,
          };
          i.commentReplies.forEach((item, index) => {
            if (item.commentReplyName) {
              set(chartData, item.commentReplyName, item.count);
            } else {
              set(
                chartData,
                `${CHART_DATA_EMPTY_KEY_PREFIX}${index}`,
                item.count,
              );
            }
          });

          return chartData;
        }),
      );
    },
    [period],
  );

  const handleQuery = useCallback(() => {
    if (startDate && endDate && projectID && period) {
      queryData(
        { startDate, endDate, period },
        {
          onSuccess: onSuccess,
        },
      );
    }
  }, [endDate, onSuccess, period, projectID, queryData, startDate]);

  useEffect(handleQuery, [handleQuery, currentLocale]);

  return (
    <ChartLine
      data={chartData}
      title={t('dataDashboard.numberOfUniqueUsers')}
      emptyDisplayName={t('dataDashboard.deletedFlow')}
      labelLimit={21}
      isLoading={isLoading}
    />
  );
};

export default DataDashboardSourceCommentAutoReplyChart;
